export const formatNumberToShortString = (num) => {
    if (num >= 1000000) {
        return (num / 1000000).toFixed() + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed() + 'k';
    }
    return String(num);
};
/**
 * Parse JSON, returning `fallback` instead of throwing on malformed input.
 * Use for untrusted sources such as localStorage values.
 */
export const safeJsonParse = (value, fallback) => {
    if (value === null) {
        return fallback;
    }
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return fallback;
    }
};
export const has4ConsecutiveSpaces = (str) => {
    return /[ ]{4,}/g.test(str);
};
export const hasTwoConsecutiveNewlines = (str) => {
    return /\n{3,}/.test(str);
};
export const hasNewLine = (str) => {
    return /\r?\n|\r/g.test(str);
};
export const hasTab = (str) => {
    return /[\t]/g.test(str);
};
